import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { Css, ITheme } from '../../../../ui';
import { RouterLink } from '../../link/RouterLink';

export const InfoCardDivider = styled.hr`
	border-top: 1px solid ${Color.BorderCard};
	margin-bottom: ${Css.pxToRem(24)};
`;

export const InfoCard = styled.div`
	border-radius: 4px;
	border: 1px solid ${Color.BorderCard};
	background-color: ${Color.Neutral2};
	padding: ${Css.pxToRem(16)};
`;

export const InfoCardTop = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const InfoCardTitleSection = styled.div`
	display: flex;
	align-items: center;
	gap: ${Css.pxToRem(16)};
`;

export const InfoCardTitle = styled.h5`
	margin-bottom: 0;
`;

export const InfoCardTopRightSection = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: flex-end;
`;

export const InfoCardDescription = styled.div`
	color: ${Color.Neutral6};
`;

export const InfoCardIcons = styled.div`
	display: flex;
	gap: ${Css.pxToRem(3)};
`;

export const InfoCardRemark = styled.div`
	font-weight: 500;
`;

export const InfoCardLink = styled(RouterLink)<{}, ITheme>`
	text-decoration: none;
	color: ${(props) => props.theme.color.secondary};
	font-weight: 700;

	&:hover {
		color: ${(props) => props.theme.button.textButton.hover.font.color};
	}
`;
